module.exports = __webpack_public_path__ + "static/media/Portrait-10252.f4505138.jpg";